export default "__VITE_ASSET__d66cf3cb__"